export default "__VITE_ASSET__3ca666ee__"